import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";

export const adminMenuList = [
  {
    name: "Administration",
    icon: AdminPanelSettingsOutlinedIcon,
    link: "administration",
  },
  {
    name: "Customer",
    icon: PeopleAltOutlinedIcon,
    link: "customer",
  },
  {
    name: "Medicines",
    icon: MedicationOutlinedIcon,
    link: "medicines",
  },
  {
    name: "Review",
    icon: RateReviewOutlinedIcon,
    link: "review",
  },
  {
    name: "Orders",
    icon: ShoppingCartOutlinedIcon,
    link: "orders",
  },
  {
    name: "Delivery Methods",
    icon: LocalShippingOutlinedIcon,
    link: "delivery",
  },
  {
    name: "Payment Methods",
    icon: PaymentOutlinedIcon,
    link: "payment",
  },
  {
    name: "Reports",
    icon: AssessmentOutlinedIcon,
    link: "reports",
  },

  {
    name: "Blog",
    icon: ArticleOutlinedIcon,
    link: "blog",
  },
  {
    name: "Supplier",
    icon: HandshakeOutlinedIcon,
    link: "supplier",
  },
  {
    name: "Expanse Calculation",
    icon: CalculateOutlinedIcon,
    link: "expense-calc",
  },
  {
    name: "Website Settings",
    icon: PublicOutlinedIcon,
    link: "web-settings",
  },
];
